import CustomButton from '../../../common/components/CustomButton';
import CurrencyUtility from '../../../common/utility/CurrencyUtility';

export default function KaraokeRegistrationCancelFormView2({
  isBeforePayment,
  paymentAmount,
  isAvailableOnNextone,
  onBackToHome,
} : {
  isBeforePayment: boolean,
  paymentAmount: number,
  isAvailableOnNextone: boolean,
  onBackToHome: () => void,
}) {
  return (
    <form>
      <div className="form__body">
        <dl>
          <dd>
            {isAvailableOnNextone ? (
              <>
                著作権管理委託終了の依頼が完了しました。
                <br />
                <br />
                「著作権管理委託の終了依頼完了」というメールが届いているか必ず確認してください。
                <br />
              </>
            ) : (
              <>
                プラン変更の依頼が完了しました。
                <br />
                <br />
                「印税なしに変更 受付完了」というメールが届いているか必ず確認してください。
                <br />
              </>
            )}
            (届かない場合は
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a href="https://help.frekul.com/140/" target="_blank">こちら</a>
            からお問合せください。)
            <br />
            {isBeforePayment && (
              <>
                <br />
                {`変更後のお支払い金額は【${CurrencyUtility.format(paymentAmount - 5000)}円】です。`}
                <br />
                入金確認後、修正作業に順次着手します。
                <br />
                <br />
                以下の口座にお振込みをお願いします。
                <br />
                <br />
                PayPay銀行（銀行コード 0033）
                <br />
                すずめ支店（店番号 002）
                <br />
                普通 7713904
                <br />
                口座名義：株式会社ワールドスケープ
                <br />
                カタカナ表記の場合：カ）ワールドスケープ
                <br />
                <br />
                ※お申込者名とお振込み名義が違う場合は、振込の際備考欄（通信欄）にお申込者名をご記載ください。
                <br />
                ※振込手数料はご負担をお願いいたします。
                <br />
              </>
            )}
          </dd>
        </dl>
        <p className="top_line" />
        <ul>
          <li className="bt">
            <CustomButton type="cancel" onClick={() => onBackToHome()}>ホームに戻る</CustomButton>
          </li>
        </ul>
      </div>
    </form>
  );
}
